<template>
  <div class="main">
    <div class="row">
      <div class="head">
        <div class="topBox">
          <img src="https://www.tjh.com.cn/patient/img/logo.png" alt="" class="logo">
          <div class="shu" v-if="windowWidth > 768"></div>
          <div class="text">{{deptName}}</div>
          <div class="shu"></div>
          <div class="typeBox">
            <div class="t_item" v-if="typeindex==0">医师/医技/其他</div>
            <div class="t_item" v-if="typeindex==1">护理</div>
          </div>
        </div>

        <div class="leftNav" v-if="typeindex==0">
          <div :class="nav==0?'l_item l_item_a':'l_item'" @click="navClick(0)" v-if="html">
            <img src="@/assets/2-1.png" alt="" fit='contain' v-if="nav==0">
            <img src="@/assets/1-1.png" alt="" fit='contain' v-if="nav!=0">
            <span>科室简介</span>
          </div>
          <div :class="nav==1?'l_item l_item_a':'l_item'" @click="navClick(1)" v-if="html2">
            <img src="@/assets/2-2.png" alt="" fit='contain' v-if="nav==1">
            <img src="@/assets/1-2.png" alt="" fit='contain' v-if="nav!=1">
            <span>研究方向</span>
          </div>
          <div :class="nav==2?'l_item l_item_a':'l_item'" @click="navClick(2)" v-if="html3">
            <img src="@/assets/2-3.png" alt="" fit='contain' v-if="nav==2">
            <img src="@/assets/1-3.png" alt="" fit='contain' v-if="nav!=2">
            <span>学习内容</span>
          </div>
          <div :class="nav==3?'l_item l_item_a':'l_item'" @click="navClick(3)" v-if="html4">
            <img src="@/assets/2-4.png" alt="" fit='contain' v-if="nav==3">
            <img src="@/assets/1-4.png" alt="" fit='contain' v-if="nav!=3">
            <span>申请方式</span>
          </div>
        </div>

        <div class="leftNav" v-if="typeindex==1">
          <div :class="nav==0?'l_item l_item_a':'l_item'" @click="navClick(0)" v-if="html">
            <img src="@/assets/2-1.png" alt="" fit='contain' v-if="nav==0">
            <img src="@/assets/1-1.png" alt="" fit='contain' v-if="nav!=0">
            <span>科室简介</span>
          </div>
          <div :class="nav==1?'l_item l_item_a':'l_item'" @click="navClick(1)" v-if="html2">
            <img src="@/assets/2-2.png" alt="" fit='contain' v-if="nav==1">
            <img src="@/assets/1-2.png" alt="" fit='contain' v-if="nav!=1">
            <span>研修方向及内容</span>
          </div>
          <div :class="nav==3?'l_item l_item_a':'l_item'" @click="navClick(3)" v-if="html4">
            <img src="@/assets/2-4.png" alt="" fit='contain' v-if="nav==3">
            <img src="@/assets/1-4.png" alt="" fit='contain' v-if="nav!=3">
            <span>申请方式及要求</span>
          </div>
        </div>
      </div>

      <div class="content">
        <div v-html="html" v-if="nav==0"></div>

        <div v-html="html2" v-if="nav==1"></div>

        <div v-html="html3" v-if="nav==2"></div>

        <div v-html="html4" v-if="nav==3"></div>
      </div>

      <div class="btn" @click="toApply">立即申请</div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
  export default {
    name: "deptNav",
    inject:["reload"],
    components:{

    },
    data () {
      return {
        navData:[
          {name:'科室简介',url1:'@/assets/jj.png',url2:'@/assets/jj.png'},
          {name:'研究方向',url1:'@/assets/jj.png',url2:'@/assets/jj.png'},
          {name:'学习内容',url1:'@/assets/jj.png',url2:'@/assets/jj.png'},
          {name:'申请方式',url1:'@/assets/jj.png',url2:'@/assets/jj.png'},
        ],
        nav:'0',
        typeindex:'0',

        html:'',
        html2:'',
        html3:'',
        html4:'',

        disabled:false,

        windowWidth:'',

        deptName:'',
      }
    },
    computed:{
        
    },
    watch: {
      
    },
    created(){  //载入前
      if(!this.$route.query.type){
        this.$alert('地址路径有误！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            window.close()
          }
        });
        return
      }

      if(this.$route.query.deptName){
        this.deptName = this.$route.query.deptName = this.$route.query.deptName
      }
      
      if(this.$route.query.type){
        this.typeindex = this.$route.query.type == '医师医技' ? '0' : '1'
      }
      
      if(this.$route.query.preview){
        axios.post('/publicize/viewInfoById',{id: this.$route.query.preview}).then((res)=>{
          if(res.data.code == 0){
            this.html = res.data.data.content
            this.html2 = res.data.data.content2
            this.html3 = res.data.data.content3
            this.html4 = res.data.data.content4
            this.disabled = true
          }
        }).catch(err=>{
          //console.log(err)
        })
      }else if(this.$route.query.approval){
        axios.post('/publicize/promotionRecordInfo',{id: this.$route.query.approval}).then((res)=>{
          if(res.data.code == 0){
            this.html = res.data.data.content
            this.html2 = res.data.data.content2
            this.html3 = res.data.data.content3
            this.html4 = res.data.data.content4
            this.disabled = true
          }
        }).catch(err=>{
          //console.log(err)
        })
      }else{
        this.infoData()
      }
    },
    mounted(){
      window.fullWidth = document.documentElement.clientWidth;
      this.windowWidth = window.fullWidth; // 宽
    },
    methods:{  //业务
      //访问记录
      previewLog(moudelName){
        let params = {
          moudelName:moudelName,
        }
        axios.post('/publicize/saveViewLog',params).then((res)=>{
          if(res.data.code == 0){
              
          }
        }).catch(err=>{
        //console.log(err)
        })
      },
      navClick(index){
        this.nav = index
      },
      typeClick(index){
        if(this.disabled){
          this.$message({
            message: '预览模式，无法切换类别',
            type: 'warning'
          });
          return
        }
        this.typeindex = index
        this.infoData()
      },
      toApply(){
        this.previewLog('科室介绍点击立即申请')
        window.open('https://eduapply.tjh.com.cn/','_blank')
      },
      infoData(){
        let url = this.typeindex == '0' ? '/publicize/promotionBaseInfo' : '/publicize/promotionBaseInfoHl'
        axios.post(url,{id: this.$route.query.deptId}).then((res)=>{
          if(res.data.code == 0){
            this.html = this.typeindex==0?res.data.data.ysyjContent:res.data.data.hlContent
            this.html2 = this.typeindex==0?res.data.data.ysyjContent2:res.data.data.hlContent2
            this.html3 = this.typeindex==0?res.data.data.ysyjContent3:res.data.data.hlContent3
            this.html4 = this.typeindex==0?res.data.data.ysyjContent4:res.data.data.hlContent4
          }
        }).catch(err=>{
          //console.log(err)
        })
      },
    }
  }
</script>

<style lang='scss' scoped>
.main{
  width: 100vw;
  height: calc(100vh - 180px);
  // background: #f0f0f0;
  overflow-y: auto;
  margin-top: 180px;
}
.row{
  width: 1100px;
  margin: 0 auto;
  // padding-top: 145px;
  padding-bottom: 20px;
  position: relative;
}
.head{
  width: 1300px;
  // height: 100px;
  padding-top: 20px;
  position: fixed;
  top: 0;
  left: 50%;
  margin-left: -650px;
  // background: #fff;
  border-bottom: 1px solid rgb(182, 182, 182);
}
.topBox{
  width: 1200px;
  display: flex;
  align-items: center;
  justify-content: center;
  .logo{
    width: 495px;
  }
  .shu{
    width: 1px;
    height: 35px;
    background: rgb(182, 182, 182);
    margin: 0 30px;
  }
  .text{
    font-size: 28px;
    font-weight: bold;
    color: #333;
    text-shadow: 3px 3px 3px rgb(201, 201, 201);
    letter-spacing: 2px;
  }
}
.navBox{
  width: 1200px;
  display: flex;
  align-items: center;
  justify-content: center;
  .n_item{
    margin: 10px 40px 0px;
    width: 200px;
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    color: #666;
    text-align: center;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 4px solid #fff;
    .icons{
      width: 24px;
      height: 24px;
      margin-right: 10px;
    }
    &:hover{
      // color: #4b9a7b;
      // font-weight: bold;
    }
  }
  .n_item_a{
    border-bottom: 4px solid #4b9a7b;
    color: #4b9a7b;
    font-weight: bold;
  }
}
.content{
  width: 100%;
  // height: calc(100vh - 335px);
  min-height: 335px;
  overflow-y: auto;
  padding: 0 2px;
  .title-image{
    width: 140px;
    margin: 40px auto 10px;
    display: block;
  }
  .c_text{
    font-size: 18px;
    text-indent: 36px;
    line-height: 32px;
    margin-top: 5px;
    margin-bottom: 20px;
  }
  .circle{
    list-style-type: disc;
  }
  li{
    text-indent: 0px;
  }
}
.btn{
  width: 200px;
  height: 40px;
  background: #4b9a7b;
  border-radius: 5px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 1px;
  margin: 30px auto 20px;
  cursor: pointer;
  &:hover{
    opacity: 0.9;
  }
}

.leftNav{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  .l_item{
    font-size: 20px;
    font-weight: bold;
    padding: 8px 20px;
    color: #333;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin: 0 35px;
    border-radius: 5px 5px 0 0;
    img{
      margin: 0 auto;
      display: block;
      width: 20px;
    }
    span{
      display: block;
      text-align: center;
      margin: 0 auto;
      margin-left: 5px;
      letter-spacing: 1px;
    }
  }

  .l_item_a{
    background: #4b9b7b;
    color: #fff;
  }
}
.typeBox{
  .t_item{
    font-size: 20px;
    text-align: left;
    margin: 5px 0;
    color: #666;
    cursor: pointer;
    border: 1px solid #fff;
    padding: 2px 4px;
    border-radius: 4px;
    text-align: center;
  }
  .t_item_a{
    color: #4b9b7b;
    border: 1px solid #4b9b7b;
  }
}


@media only screen and (max-width: 768px) {
.main{
  width: 100vw;
  height: calc(100vh - 180px);
  // background: #f0f0f0;
  overflow-y: auto;
  margin-top: 180px;
}
.row{
  width: 100%;
  margin: 0 auto;
  // padding-top: 145px;
  padding-bottom: 20px;
  position: relative;
}
.head{
  width: 100%;
  // height: 100px;
  padding-top: 20px;
  position: fixed;
  top: 0;
  left: 50%;
  margin-left: -50%;
  // background: #fff;
  border-bottom: 1px solid rgb(182, 182, 182);
}
.topBox{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  .logo{
    width: 80%;
  }
  .shu{
    width: 1px;
    height: 35px;
    background: rgb(182, 182, 182);
    margin: 0 10px;
  }
  .text{
    font-size: 18px;
    font-weight: bold;
    color: #333;
    text-shadow: 3px 3px 3px rgb(201, 201, 201);
    letter-spacing: 2px;
  }
}
.content{
  width: 100%;
  // height: calc(100vh - 335px);
  min-height: 335px;
  overflow-y: auto;
  padding: 0 5px;
  .title-image{
    width: 140px;
    margin: 40px auto 10px;
    display: block;
  }
  .c_text{
    font-size: 18px;
    text-indent: 36px;
    line-height: 32px;
    margin-top: 5px;
    margin-bottom: 20px;
  }
  .circle{
    list-style-type: disc;
  }
  li{
    text-indent: 0px;
  }
}
.btn{
  width: 200px;
  height: 34px;
  background: #4b9a7b;
  border-radius: 5px;
  line-height: 34px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
  margin: 30px auto 20px;
  cursor: pointer;
  &:hover{
    opacity: 0.9;
  }
}

.leftNav{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 6px;
  .l_item{
    font-size: 14px;
    font-weight: bold;
    padding: 4px 5px;
    color: #333;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin: 0 5px;
    border-radius: 5px 5px 0 0;
    img{
      margin: 0 auto;
      display: block;
      width: 15px;
    }
    span{
      display: block;
      text-align: center;
      margin: 0 auto;
      margin-left: 3px;
      letter-spacing: 1px;
    }
  }

  .l_item_a{
    background: #4b9b7b;
    color: #fff;
  }
}
.typeBox{
  .t_item{
    font-size: 14px;
    text-align: left;
    margin: 2px 0;
    color: #666;
    cursor: pointer;
    border: 1px solid #fff;
    padding: 2px 4px;
    border-radius: 4px;
    text-align: center;
  }
  .t_item_a{
    color: #4b9b7b;
    border: 1px solid #4b9b7b;
  }
}
}
</style>



// WEBPACK FOOTER //
// src/pages/deptNav/details.vue